import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export type ConfirmModalIcon = 'warning' | 'info' | 'error' | 'none';
export type ConfirmModalVariant = 'danger' | 'theme';

/**
 * Shared "are you sure?" confirmation dialog. Presentational only — it
 * never performs the confirmed action itself. Callers subscribe to
 * `confirmClick` and decide when to close the modal (immediately, or after
 * an async call completes, toggling `isLoading` in the meantime).
 *
 * const modalRef = this.modalService.open(ConfirmModalComponent, { centered: true });
 * modalRef.componentInstance.title = 'Leave this city?';
 * modalRef.componentInstance.message = 'You will return to the main map.';
 * modalRef.componentInstance.confirmClick.subscribe(() => modalRef.close(true));
 */
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: false,
})
export class ConfirmModalComponent {
  @Input() title = 'Please Confirm';
  @Input() message = '';
  @Input() paragraphs: string[] | null = null;
  @Input() confirmLabel = 'Confirm';
  @Input() cancelLabel = 'Cancel';
  @Input() confirmVariant: ConfirmModalVariant = 'danger';
  /** Leave unset to pick a sensible default from confirmVariant (danger -> warning, theme -> info). */
  @Input() icon: ConfirmModalIcon | null = null;
  @Input() isLoading = false;
  @Input() showCancel = true;

  @Output() confirmClick = new EventEmitter<void>();

  constructor(public activeModal: NgbActiveModal) {}

  get effectiveIcon(): ConfirmModalIcon {
    return this.icon ?? (this.confirmVariant === 'theme' ? 'info' : 'warning');
  }

  onConfirm(): void {
    this.confirmClick.emit();
  }

  cancel(): void {
    this.activeModal.close(false);
  }
}
